import FacetSearchStore from "@javascript/stores/facetSearchStore";

import Heading from "@reactComponents/lds/typography/Heading";

const FacetSearchCriteriaHeading = () => {
  // this should be refactored as initial state when hooking this component up to FacetSearchStore
  const total_count_formatted = commifyNumber(FacetSearchStore.data.total_count);

  return (
    <div className="applied_filters_heading">
      <Heading
        leadingIcon="filter"
        size="h3"
      >Applied Filters</Heading>
      <p>Current search is narrowed to <b style={{display: "inline-block"}} className={`rspec_search_total_count animate__animated animate__fadeInDown`}>{total_count_formatted}</b> event{FacetSearchStore.data.total_count === 1 ? "" : "s"}</p>
    </div>
  )
}

window.FacetSearchCriteriaHeading = FacetSearchCriteriaHeading;
export default FacetSearchCriteriaHeading;
